import React from 'react';
import useBreakpoint from '@common/utils/useBreakpoint';
import Icon from '@stone/ui/icon/Icon';
import { useTranslation } from 'react-i18next';
import { useReducedMotion } from 'framer-motion';
import ShopByCategorySlideshow from './ShopByCategorySlideshow';
import '@stone/scss/components/shop-by-category/_shop-by-category.scss';
import ButtonPlayPause from '@stone/ui/button/ButtonPlayPause';
import useProductsList from '@stone/hooks/useProductsList';
import { compileListName } from '@stone/utils/analytics';
const ShopByCategory = (props) => {
    // ANCHOR - HOOKS --------------------------------------------------------------------
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const isReduced = useReducedMotion();
    const { parseCategories } = useProductsList();
    // ANCHOR - USE MEMO --------------------------------------------------------------------
    const categories = parseCategories(props.categories);
    // ANCHOR - COMPONENTS --------------------------------------------------------------------
    const renderNavigation = () => (React.createElement(React.Fragment, null,
        currentBreakpoint >= window.mqObj.lg && React.createElement(ButtonPlayPause, { initialState: isReduced ? 'play' : 'pause', refUUID: props.uuid }),
        React.createElement("div", { className: "navigation" },
            React.createElement("button", { className: "button sbc-navigation--prev", "aria-label": t('carousel.prevslidemessage') },
                React.createElement(Icon, { name: "left-chevron", family: "10" })),
            React.createElement("button", { className: "button sbc-navigation--next", "aria-label": t('carousel.nextslidemessage') },
                React.createElement(Icon, { name: "right-chevron", family: "10" })))));
    if (!(categories === null || categories === void 0 ? void 0 : categories.length))
        return React.createElement(React.Fragment, null);
    // ANCHOR - RENDER --------------------------------------------------------------------
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row shop-by-category__intro" },
                React.createElement("div", { className: "col-lg-5" },
                    React.createElement("div", { className: "shop-by-category__title" },
                        React.createElement("h2", { className: "font__title" }, props.title),
                        currentBreakpoint < window.mqObj.lg && renderNavigation())),
                React.createElement("div", { className: "col-lg-8 col-xxl-6" },
                    React.createElement("p", null, props.description)),
                currentBreakpoint >= window.mqObj.lg && (React.createElement("div", { className: "col-fill" },
                    React.createElement("div", { className: "d-flex align-middle justify-end gap-24" },
                        React.createElement("div", { id: `navigation_${props.uuid}`, className: "d-flex align-middle" }),
                        renderNavigation()))))),
        React.createElement("div", { className: "shop-by-category__slideshow--wrapper" },
            React.createElement(ShopByCategorySlideshow, { categories: categories, uuid: props.uuid, itemListName: compileListName(props.itemListName || 'shop by category') }))));
};
export default ShopByCategory;
